import * as Yup from "yup";
import moment from "moment";

// Generate the last 3 completed months
export const getLastThreeCompletedMonths = () => {
  const months = [];
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the current date and go back to the first day of the current month
  const today = moment();
  const currentMonth = moment(today).startOf("month");

  // Generate last 3 completed months (not including current month)
  for (let i = 1; i <= 3; i++) {
    const monthDate = moment(currentMonth).subtract(i, "months");
    const firstDayOfMonth = moment(monthDate).startOf("month");
    const monthName = monthNames[monthDate.month()];
    const year = monthDate.year();
    const value = firstDayOfMonth.format("YYYY-MM-DD");

    months.push({
      label: `${monthName} ${year}`,
      value: value,
    });
  }

  return months;
};

export const monthlyReportInitialValues = {
  reportDate: "",
};

// Get valid month values for validation
const validMonthValues = getLastThreeCompletedMonths().map((month) => month.value);

export const monthlyReportValidationSchema = Yup.object().shape({
  reportDate: Yup.string()
    .required("Month is required")
    .oneOf(validMonthValues, "Please select a valid month"),
});

